import React from 'react';
import { Box, Typography, Paper, Grid, Card, CardActionArea, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const blogPosts = [
    {
        title: 'మీరు పోగొట్టుకున్న సర్టిఫికేట్లను తిరిగి ఎలా పొందాలి?',
        description: 'మీ ముఖ్యమైన విద్యా లేదా ఇతర సర్టిఫికేట్లు పోయాయా? చింతించకండి. వాటిని తిరిగి పొందడానికి అనుసరించాల్సిన దశల వారీ ప్రక్రియను ఇక్కడ తెలుసుకోండి.',
        link: '/blog/how-to-find-lost-certificate'
    },
    {
        title: 'రైల్వే స్టేషన్‌లో వస్తువు పోతే ఏం చేయాలి?',
        description: 'రైలు ప్రయాణంలో లేదా రైల్వే స్టేషన్‌లో మీ వస్తువులు పోయాయా? కంగారు పడకండి. వాటిని తిరిగి కనుగొనడానికి మీరు తీసుకోవాల్సిన చర్యల గురించి ఇక్కడ తెలుసుకోండి.',
        link: '/blog/lost-item-in-railway-station'
    },
    // మీరు భవిష్యత్తులో మరిన్ని బ్లాగ్ పోస్ట్‌లను ఇక్కడ జోడించవచ్చు
];

function BlogListPage() {
    const navigate = useNavigate();

    return (
        <Paper sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>Our Blog</Typography>
            <Typography color="text.secondary" sx={{ mb: 4 }}>
                వస్తువులు పోగొట్టుకున్నప్పుడు లేదా దొరికినప్పుడు ఏమి చేయాలో తెలుసుకోవడానికి మా ఆర్టికల్స్ చదవండి.
            </Typography>
            <Grid container spacing={3}>
                {blogPosts.map((post, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card sx={{ height: '100%' }}>
                            <CardActionArea sx={{ height: '100%' }} onClick={() => navigate(post.link)}>
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {post.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {post.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
}

export default BlogListPage;
